module.exports = __webpack_public_path__ + "img/login-hotline-att.39ab9ee9.png";